import { onlyDigits } from "validators";

const payeeIdColumn = () => ({
	name: "payeeId",
	type: "input" as const,
	placeholder: "Payee ID",
	normalize: onlyDigits,
});

export default payeeIdColumn;
